import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { generate } from "library/guid/index.mjs"

export function AddRuleSetReferenceButton({ onAdd }) {
    return (
        <Button variant="outlined" startIcon={<Iconify icon="mdi:link-variant-plus" />} onClick={handleAdd}>
            Add Rule Set
        </Button>
    )

    function handleAdd() {
        onAdd({
            id: generate(),
            type: "ruleSetReference",
            enabled: true,
            ruleSetId: null,
        })
    }
}
